import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import NhanVayApi from "service/nhanVayApi";
import { formatNumber } from "utils/currencyFormat";

export const TableChiTietTraLai = ({ nhanvayId }) => {
  const searchInit = {
    nhanvayId: nhanvayId,
    pageIndex: 1,
    pageSize: 5,
  };
  const [dataSearchLanDongLai, UpdateDataSearchLanDongLai] =
    useState(searchInit);
  const dataInit = {
    List: [],
    TongTienLai: 0,
    TongTienGoc: 0,
    TongPhiKhac: 0,
    TongPhiKho: 0,
    TongCanThanhToan: 0,
    TongThanhToan: 0,
    TongBanGhi: 0,
  };
  const [dataLanDongLai, UpdateDataLanDongLai] = useState(dataInit);

  useEffect(() => {
    UpdateDataSearchLanDongLai({
      ...dataSearchLanDongLai,
      nhanvayId: nhanvayId,
      pageIndex: 1,
      pageSize: 5,
    });
    NhanVayApi.lanThanhToan1(
      dataSearchLanDongLai.nhanvayId,
      dataSearchLanDongLai.pageIndex,
      dataSearchLanDongLai.pageSize
    ).then((response) => {
      UpdateDataLanDongLai({
        ...dataLanDongLai,
        List: response.data.List,
        TongTienLai: response.data.TongTienLai,
        TongTienGoc: response.data.TongTienGoc,
        TongPhiKhac: response.data.TongPhiKhac,
        TongPhiKho: response.data.TongPhiKho,
        TongCanThanhToan: response.data.TongCanThanhToan,
        TongThanhToan: response.data.TongThanhToan,
        TongBanGhi: response.data.TongBanGhi,
      });
    });
  }, []);

  const PhanTrang = (index) => {
    dataSearchLanDongLai.pageIndex = index;
    NhanVayApi.lanThanhToan1(
      dataSearchLanDongLai.nhanvayId,
      dataSearchLanDongLai.pageIndex,
      dataSearchLanDongLai.pageSize
    ).then((response) => {
      UpdateDataLanDongLai({
        ...dataLanDongLai,
        List: response.data.List,
        TongTienLai: response.data.TongTienLai,
        TongTienGoc: response.data.TongTienGoc,
        TongPhiKhac: response.data.TongPhiKhac,
        TongPhiKho: response.data.TongPhiKho,
        TongCanThanhToan: response.data.TongCanThanhToan,
        TongThanhToan: response.data.TongThanhToan,
        TongBanGhi: response.data.TongBanGhi,
      });
    });
  };

  //show hide lần đóng lại trên mobile
  let isShow = true;
  let displayText = "contents";
  if (matchMedia) {
    var mq = window.matchMedia("(max-width: 768px)");
    isShow = !mq.matches;
    if (mq.matches) displayText = "block";
  }
  const itemShowinit = {
    item: null,
    isShow: isShow,
    displayText,
  };
  const [dataShowItem, SetDataShowItem] = useState(itemShowinit);

  const showRow = (item) => () => {
    let isShow = true;
    if (matchMedia) {
      var mq = window.matchMedia("(max-width: 768px)");
      isShow = mq.matches && !dataShowItem.isShow;
    }
    dataShowItem.item = item;
    dataShowItem.isShow = isShow;
    SetDataShowItem({
      ...dataShowItem,
      item: item,
      isShow: isShow,
      displayText,
    });
  };
  //End-show hide lần đóng lại trên mobile
  const listItem = () => {
    return (
      dataLanDongLai.List != null &&
      dataLanDongLai.List.map((item, index) => {
        return (
          <>
            <div className="custom-table-row">
              <div className="custom-table-cell username-cell flex-basis-8 disk-mobile">
                <span className="mobile-column-name">STT</span>
                <div className="center-wrapper">
                  <p className="text-center">
                    {index + 1 + (dataSearchLanDongLai.pageIndex - 1) * 5}
                  </p>
                </div>
              </div>

              <div className="row-show-three">
                <div className="row-mobile">
                  <div class="custom-table-cell flex-basis-12">
                    <span className="mobile-column-name disk-mobile">
                      Ngày trả lãi
                    </span>
                    <div className="center-wrapper">
                      <p
                        className="icon-dropdown-mobile"
                        onClick={showRow(item)}
                      >
                        <i className="mdi mdi-arrow-down-drop-circle collapsible"></i>
                        {item.NgayTraLai}
                      </p>
                    </div>
                  </div>

                  <div class="custom-table-cell flex-basis-15  flex-basis-20-responsive flex-disk">
                    <span className="mobile-column-name disk-mobile">
                      Tiền lãi
                    </span>
                    <div className="center-wrapper">
                      <p className="text-right1">
                        {formatNumber(item.TienLai)}
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  class="form-row-detail content12"
                  style={{
                    display:
                      dataShowItem.isShow &&
                      (!dataShowItem.item || dataShowItem.item === item)
                        ? dataShowItem.displayText
                        : "none",
                  }}
                >
                  <div class="custom-table-cell flex-basis-15 flex-basis-20-responsive">
                    <span className="mobile-column-name">Tiền gốc</span>
                    <div className="center-wrapper">
                      <p className="text-right1">
                        {formatNumber(item.TienGoc)}
                      </p>
                    </div>
                  </div>

                  <div class="custom-table-cell flex-basis-7-5  flex-basis-7-5-sm">
                    <span className="mobile-column-name">Phí khác</span>
                    <div className="center-wrapper">
                      <p className="text-right">{formatNumber(item.PhiKhac)}</p>
                    </div>
                  </div>

                  {/* <div class="custom-table-cell flex-basis-7-5  flex-basis-7-5-sm">
                    <span className="mobile-column-name">Phí kho</span>
                    <div className="center-wrapper">
                      <p className="text-right">{formatNumber(item.PhiKho)}</p>
                    </div>
                  </div> */}

                  <div class="custom-table-cell flex-basis-15 flex-basis-20-responsive ">
                    <span className="mobile-column-name">Số tiền đã trả</span>
                    <div className="center-wrapper">
                      <p className="text-right">
                        {formatNumber(item.DaThanhToan)}
                      </p>
                    </div>
                  </div>

                  <div class="custom-table-cell flex-basis-20  ">
                    <span className="mobile-column-name">Các lần đóng</span>
                    <div className="center-wrapper">
                      {item.CacLanDong.map((item) => (
                        <>
                          <p class="text-center">
                            <a href={() => false}>
                              {formatNumber(item.TienThanhToan * -1)}
                            </a>{" "}
                            <span class="date-sm">
                              ({item.ThoiGianThanhToan})
                            </span>
                          </p>
                        </>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      })
    );
  };
  return (
    <div className="Left808x200 Table-main-new table-mobile-new1 col-xl-12 col-lg-12">
      <div className="table-responsive table-responsive-new table-new1">
        <div className="custom-table-wrapper custom-border-mm">
          <div className="table-headers">
            <div className="custom-table-header flex-basis-8">
              <p className="text-center">
                STT
                <br />{" "}
                <span className="red">[ {dataLanDongLai.TongBanGhi} ]</span>
              </p>
            </div>
            <div className="custom-table-header flex-basis-12   ">
              <p>Ngày trả lãi</p>
            </div>
            <div className="custom-table-header flex-basis-15 flex-basis-20-responsive">
              <p className="text-right">
                Tiền lãi
                <br />
                <span className="red">
                  {formatNumber(dataLanDongLai.TongTienLai)}
                </span>
              </p>
            </div>
            <div className="custom-table-header flex-basis-15 flex-basis-20-responsive">
              <p className="text-right">
                Tiền gốc
                <br />
                <span className="red">
                  {formatNumber(dataLanDongLai.TongTienGoc)}
                </span>
              </p>
            </div>
            <div className="custom-table-header flex-basis-7-5 flex-basis-7-5-sm">
              <p className="text-right">
                Phí khác
                <br />
                <span className="red">
                  {formatNumber(dataLanDongLai.TongPhiKhac)}
                </span>
              </p>
            </div>
            {/* <div className="custom-table-header flex-basis-7-5 flex-basis-7-5-sm">
              <p className="text-right">
                Phí kho
                <br />  
                <span className="red">
                  {formatNumber(dataLanDongLai.TongPhiKho)}
                </span>
              </p>
            </div> */}

            <div className="custom-table-header flex-basis-15 flex-basis-20-responsive">
              <p className="text-right">
                Số tiền đã trả <br />
                <span className="home-new-blue">
                  {formatNumber(dataLanDongLai.TongThanhToan)}
                </span>
              </p>
            </div>

            <div className="custom-table-header flex-basis-20 ">
              <p className="tab-header text-center">Các lần đóng</p>
            </div>
          </div>

          <div className="custom-table-body">
            <div className="custom-table-row">
              <div className="custom-table-cell username-cell-mobile flex-basis-15 flex-disk disk-desktop show-mobile">
                <span className="mobile-column-name">Ngày trả lãi</span>
                <div className="center-wrapper  ">
                  <p className="text-right1">Tiền lãi</p>
                </div>
              </div>
            </div>
            {listItem()}
          </div>
        </div>
      </div>

      <div class="footer-page-new">
        <div class="row">
          <div class="col-xl-6 col-lg-12"></div>

          <div class="col-xl-6 col-lg-12">
            <div class="paniation-new d-flex just-end">
              <nav aria-label="Page navigation">
                <Pagination
                  activePage={dataSearchLanDongLai.pageIndex}
                  itemsCountPerPage={dataSearchLanDongLai.pageSize}
                  totalItemsCount={dataLanDongLai.TongBanGhi}
                  pageRangeDisplayed={5}
                  onChange={PhanTrang}
                  itemClass="page-item border-none"
                  linkClass="page-link border-none"
                  activeClass="active"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
